import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { ThemeProvider } from '@mui/styles';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Select from "react-select";
import { BlueButton } from "../components/BlueButton";
import { GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser } from "../services/Session";
import { GetXlsxAwaitingPreOrderSaleCustomer, GetXlsxOrderDetails, GetXlsxOrderSummaries, GetXlsxTopCustomer } from '../services/Transaction';
import { GetXlsxUser } from '../services/User';
import '../styles/style.css';
import theme from '../styles/theme';

const BackIcon = '/assets/svg/back.svg'
const FilterIcon = "/assets/svg/filter.svg";

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingSalesSummaryXlsx: false,
      isLoadingSalesDetailPdf: false,
      isLoadingSalesDetailXlsx: false,
      isLoadingTopCustomerXlsx: false,
      isLoadingTopProductXlsx: false,
      isLoadingAwaitingPreOrderCustomerXlsx: false,
      isLoadingUserXlsx: false,
      isOpenFilter: false,
      startDate: "",
      endDate: "",
      raw_type_filter: [],
      raw_status_filter: [],
      filters: {
        'payment.paid_at.$gte': dayjs().format('YYYY-MM-01'),
        'payment.paid_at.$lt': dayjs().add(1, 'day').format('YYYY-MM-DD'),
        sorts: "created_at",
      },
      results: [],
      order_summary: {
        count: 0,
        delivery_cost: 0,
        amount: 0,
      }
    };
  }

  downloadSalesSummaryXlsx = () => {
    this.setState({ isLoadingSalesSummaryXlsx: true })
    GetXlsxOrderSummaries(this.state.filters).then(res => {
      this.setState({ isLoadingSalesSummaryXlsx: false })
      const downloadUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'penjualan-rangkuman_' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(err => {
      this.setState({ isLoadingSalesSummaryXlsx: false })
      if (err.response) {
        if (err.response && err.response.status === 401) {
          if (GetToken().refresh_token !== null) {
            RefreshSession(GetToken().refresh_token)
          } else {
            this.handleLogout()
          }
        }
      }
    })
  }

  downloadSalesDetailXlsx = () => {
    this.setState({ isLoadingSalesDetailXlsx: true })
    GetXlsxOrderDetails(this.state.filters).then(res => {
      this.setState({ isLoadingSalesDetailXlsx: false })
      const downloadUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'penjualan-rincian_' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(err => {
      this.setState({ isLoadingSalesDetailXlsx: false })
      if (err.response) {
        if (err.response && err.response.status === 401) {
          if (GetToken().refresh_token !== null) {
            RefreshSession(GetToken().refresh_token)
          } else {
            this.handleLogout()
          }
        }
      }
    })
  }

  downloadTopCustomerXlsx = () => {
    this.setState({ isLoadingTopCustomerXlsx: true })
    GetXlsxTopCustomer(this.state.filters).then(res => {
      this.setState({ isLoadingTopCustomerXlsx: false })
      const downloadUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'top-customer' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(err => {
      this.setState({ isLoadingTopCustomerXlsx: false })
      if (err.response) {
        if (err.response && err.response.status === 401) {
          if (GetToken().refresh_token !== null) {
            RefreshSession(GetToken().refresh_token)
          } else {
            this.handleLogout()
          }
        }
      }
    })
  }

  downloadTopProductXlsx = () => {
    this.setState({ isLoadingTopProductXlsx: true })
    GetXlsxTopProduct(this.state.filters).then(res => {
      this.setState({ isLoadingTopProductXlsx: false })
      const downloadUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'top-Product' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(err => {
      this.setState({ isLoadingTopProductXlsx: false })
      if (err.response) {
        if (err.response && err.response.status === 401) {
          if (GetToken().refresh_token !== null) {
            RefreshSession(GetToken().refresh_token)
          } else {
            this.handleLogout()
          }
        }
      }
    })
  }

  downloadAwaitingPreOrderCustomerXlsx = () => {
    this.setState({ isLoadingAwaitingPreOrderCustomerXlsx: true })
    GetXlsxAwaitingPreOrderSaleCustomer(this.state.filters).then(res => {
      this.setState({ isLoadingAwaitingPreOrderCustomerXlsx: false })
      const downloadUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'customers-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(err => {
      this.setState({ isLoadingAwaitingPreOrderCustomerXlsx: false })
      if (err.response) {
        if (err.response && err.response.status === 401) {
          if (GetToken().refresh_token !== null) {
            RefreshSession(GetToken().refresh_token)
          } else {
            this.handleLogout()
          }
        }
      }
    })
  }

  downloadUserXlsx = () => {
    this.setState({ isLoadingUserXlsx: true })
    GetXlsxUser(this.state.filters).then(res => {
      this.setState({ isLoadingUserXlsx: false })
      const downloadUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'users-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(err => {
      this.setState({ isLoadingUserXlsx: false })
      if (err.response) {
        if (err.response && err.response.status === 401) {
          if (GetToken().refresh_token !== null) {
            RefreshSession(GetToken().refresh_token)
          } else {
            this.handleLogout()
          }
        }
      }
    })
  }

  handleLogout = () => {
    GuestLogin().then(res => {
      Me(SetToken(res.data.token).access_token).then(res => {
        SetUser(res.data);
        setTimeout(this.props.history.push("/"), 3000);
      });
    });
  };

  openFilter = () => {
    this.setState({ isOpenFilter: true });
  };

  closeFilter = () => {
    this.setState({ isOpenFilter: false });
  };

  resetFilter = () => {
    this.setState({
      startDate: "",
      endDate: "",
      raw_type_filter: [],
      raw_status_filter: [],
      filters: {
        'payment.paid_at.$gte': dayjs().format('YYYY-MM-01'),
        'payment.paid_at.$lt': dayjs().add(1, 'day').format('YYYY-MM-DD'),
        sorts: "created_at",
      },
    });
  };

  applyFilter = () => {
    this.setState({
      isOpenFilter: false
    });

    this.handleGetData();
  }

  handleChangeFilterOption = (selectedOptions, filtername) => {
    if (filtername === 'type' || filtername === 'status') {
      const selected = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
      const fRaw = (filtername === 'type') ? 'raw_type_filter' : 'raw_status_filter';
      const fName = (filtername === 'type') ? 'type.$in' : 'status.$in';
      this.setState({
        [fRaw]: selectedOptions,
        filters: {
          ...this.state.filters,
          [fName]: selected.toString()
        }
      })
    } else if (filtername === 'created_at.$gte' || filtername === 'created_at.$lt' || filtername === 'payment.paid_at.$gte' || filtername === 'payment.paid_at.$lt') {
      const fValue = (filtername === 'created_at.$gte' || filtername === 'payment.paid_at.$gte') ? selectedOptions.target.value : dayjs(selectedOptions.target.value).add(1, 'days').format('YYYY-MM-DD');
      this.setState({
        [filtername]: selectedOptions.target.value,
        filters: {
          ...this.state.filters,
          [filtername]: fValue,
        }
      })
    } else if (filtername === 'sort') {
      this.setState({
        raw_sort_filter: selectedOptions,
        filters: {
          ...this.state.filters,
          sorts: selectedOptions.value
        }
      })
    } else {
      this.setState({
        [filtername]: selectedOptions.target.value,
        filters: {
          ...this.state.filters,
          [filtername]: '%' + selectedOptions.target.value + '%',
        }
      })
    }
  }

  filterDialog = () => {
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) }
    return (
      <Dialog
        open={this.state.isOpenFilter}
        onClose={this.closeFilter}
        aria-labelledby="form-dialog-title"
        className="dialog-filter"
        style={{ height: "100%" }}
      >
        <DialogTitle id="form-dialog-title">Filter</DialogTitle>
        <DialogContent>
          <div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
            <Select
              styles={selectStyles}
              isMulti
              placeholder="Tipe"
              isSearchable={true}
              value={this.state.raw_type_filter}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'type')}
              options={[
                { value: "certificate", label: "Syahadah" },
                { value: "pre_order", label: "Pre Order" },
                { value: "ready_stock", label: "Ready Stock" },
                { value: "ticket", label: "e-Ticket" },
              ]}
            />
          </div>
          <div
            className="center"
            style={{ width: 240, paddingTop: 10, paddingBottom: 10, fontFamily: 'Open Sans' }}
          >
            <Select
              styles={selectStyles}
              isMulti
              placeholder="Status"
              isSearchable={true}
              value={this.state.raw_status_filter}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'status')}
              options={[
                { value: "paid", label: "Lunas" },
                { value: "awaiting_payment", label: "Menunggu Pembayaran" },
                { value: "expired", label: "Kedaluwarsa" },
                { value: "canceled", label: "Dibatalkan" },
                { value: "rejected", label: "Ditolak" },
                { value: "refunded", label: "Dikembalikan" },
                { value: "packing", label: "Diproses" },
                { value: "shipped", label: "Dikirim" },
                { value: "delivered", label: "Sampai Tujuan" },
              ]}
            />
          </div>
          <div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
            <div style={{ paddingTop: 10, paddingBottom: 10 }}>Tanggal Bayar</div>
            <TextField
              label="Dari"
              type="date"
              defaultValue={this.state['payment.paid_at.$gte']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'payment.paid_at.$gte')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Hingga"
              type="date"
              defaultValue={this.state['payment.paid_at.$lt']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'payment.paid_at.$lt')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
            <TextField
              label="Nama Produk"
              defaultValue={this.state['catalog.name.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'catalog.name.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Nama Pelanggan"
              defaultValue={this.state['customer.name.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.name.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Nomor Whatsapp"
              defaultValue={this.state['customer.phone.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.phone.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Email"
              defaultValue={this.state['customer.email.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.email.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Virtual Account"
              defaultValue={this.state['customer.virtual_account.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.virtual_account.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Kurir"
              defaultValue={this.state['delivery_service.courier_service.name.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.courier_service.name.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Nama Penerima"
              defaultValue={this.state['delivery_service.destination_address.contact_person.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.contact_person.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Nomor HP Penerima"
              defaultValue={this.state['delivery_service.destination_address.phone.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.phone.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
            />
            <TextField
              label="Alamat Pengiriman"
              defaultValue={this.state['delivery_service.destination_address.complete.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.complete.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
            />
          </div>
          <div
            className="center"
            style={{ width: 240, paddingTop: 0, paddingBottom: 100, fontFamily: 'Open Sans' }}
          >
            <Select
              styles={selectStyles}
              placeholder="Urutkan dari yang"
              value={this.state.raw_sort_filter}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'sort')}
              options={[
                { value: "-created_at", label: "Terbaru" },
                { value: "created_at", label: "Terlama" },
              ]}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.resetFilter} color="primary">
            Atur Ulang
          </Button>
          <Button onClick={this.applyFilter} color="primary">
            Terapkan
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
          <div className="header">
            <Link to="/" style={{ position: "absolute", height: 60, width: 60, top: 0, left: 0 }}>
              <img alt="icon" src={BackIcon} />
            </Link>
            <div className="center" style={{ marginTop: 20 }}>
              <h3 className="title">Laporan</h3>
            </div>
            <div style={{ position: "absolute", height: 24, width: 60, top: 18, right: 10, cursor: 'pointer' }}>
              <img alt="icon" src={FilterIcon} onClick={this.openFilter} />
            </div>
          </div>
          <div className="wrapper">
            {this.filterDialog()}
            <div style={{ padding: 10, marginTop: 10 }}>
              <BlueButton disabled={this.state.isLoadingSalesSummaryXlsx} loading={this.state.isLoadingSalesSummaryXlsx} onClick={this.downloadSalesSummaryXlsx} width={320} text="Laporan Penjualan Rangkuman (xlsx)" />
            </div>
            <div style={{ padding: 10, marginTop: 10 }}>
              <BlueButton disabled={this.state.isLoadingSalesDetailXlsx} loading={this.state.isLoadingSalesDetailXlsx} onClick={this.downloadSalesDetailXlsx} width={320} text="Laporan Penjualan Rincian (xlsx)" />
            </div>
            <div style={{ padding: 10, marginTop: 10 }}>
              <BlueButton disabled={this.state.isLoadingTopCustomerXlsx} loading={this.state.isLoadingTopCustomerXlsx} onClick={this.downloadTopCustomerXlsx} width={320} text="Laporan Top Customer (xlsx)" />
            </div>
            <div style={{ padding: 10, marginTop: 10 }}>
              <BlueButton disabled={this.state.isLoadingTopProductXlsx} loading={this.state.isLoadingTopProductXlsx} onClick={this.downloadTopProductXlsx} width={320} text="Laporan Best Seller Product (xlsx)" />
            </div>
            <div style={{ padding: 10, marginTop: 10 }}>
              <BlueButton disabled={this.state.isLoadingAwaitingPreOrderCustomerXlsx} loading={this.state.isLoadingAwaitingPreOrderCustomerXlsx} onClick={this.downloadAwaitingPreOrderCustomerXlsx} width={320} text="Daftar Pelanggan Belum PO (xlsx)" />
            </div>
            <div style={{ padding: 10, marginTop: 10 }}>
              <BlueButton disabled={this.state.isLoadingUserXlsx} loading={this.state.isLoadingUserXlsx} onClick={this.downloadUserXlsx} width={320} text="Daftar Pengguna (xlsx)" />
            </div>
          </div>
        </div>
      </ThemeProvider>
    )
  }
}

export default Report
